import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      window.location.href = '/';
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className={`nav-logo ${isMenuOpen ? 'menu-open' : ''}`} onClick={handleLogoClick}>
          <img
            src="/logo_sigma/SVG/black_color_1.svg"
            alt="Sigma Study School Logo"
            className="nav-logo-img"
          />
          {/*<h2>Sigma Study</h2>*/}
        </Link>

        {/* Backdrop overlay - closes menu on click */}
        <div
          className={`nav-menu-backdrop ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        />

        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="nav-menu-content">
            <a href="/#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }} className="nav-link">
              Start
            </a>
            <a href="/#courses" onClick={(e) => { e.preventDefault(); scrollToSection('courses'); }} className="nav-link">
              Kursy
            </a>
            <a href="/#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }} className="nav-link">
              Cennik
            </a>
            <a href="/#teachers" onClick={(e) => { e.preventDefault(); scrollToSection('teachers'); }} className="nav-link">
              Założyciele
            </a>
            <a href="/#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }} className="nav-link">
              Opinie
            </a>
            <Link to="/faq" className={`nav-link ${location.pathname === '/faq' ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)}>
              FAQ
            </Link>
            <a href="/#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="nav-link cta-button">
              Zapisz się
            </a>
          </div>
        </div>

        <button
          className={`nav-hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Otwórz menu nawigacji"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
